import React, {useEffect, useState} from "react";
import ActivityList from "../../components/activity";
import { getActivitiesPopular } from "../../service";
import { ActivitiesData } from "../types";

function OfflineActive(){

    const [lists,setLists] = useState<Array<ActivitiesData>>([])

    useEffect(() => {
        getActivitiesPopular()
            .then(res => {
                if(res.code === 1){
                    setLists(res.data)
                }
            })
    },[])

    return <div>
        <ActivityList lists={ lists }/>
    </div>
}

export default OfflineActive
